import { Hero } from "../components/home/Hero";
import { Feature } from "../components/home/Feature";
import { FeatureTwo } from "../components/home/FeatureTwo";
import { Benefits } from "../components/home/Benefits";
import { Requisitos } from "../components/home/Requisitos";
import { Space } from "../components/home/Space";
import { useSearchParams } from "react-router-dom";
import { UtmLeadService } from "../services/utmleads/utmLeads.service";
import TagManager from "../components/googleTag/TagManager";
import { Media } from "../components/home/Media";


export function HomePage() {

  console.log('HomePage - HomePage');
  const [searchParams] = useSearchParams();

  const utm_id = searchParams.get('utm_id'); //utm_id
  const click_id = searchParams.get('click_id'); //click_id
  const visitor = searchParams.get('v'); //visitor = click_id
  const partnerId = searchParams.get('partnerId'); //partnerId

  if (utm_id) {
    localStorage.setItem('utm_id', utm_id);
  }
  if (click_id) {
    localStorage.setItem('click_id', click_id);
  }
  if (visitor) {
    localStorage.setItem('visitor', visitor);
  }
  if (partnerId) {
    localStorage.setItem('partnerId', partnerId);
  }

  if (click_id && partnerId) {
    //Crear utm en db
    let payload = {
      partnerId: partnerId,
      clickId: click_id
    }
    UtmLeadService.createUtmLead({ payload })
      .then((data) => {
        if (data.error === false) {
          if ('data' in data.message) {
            let response = data.message.data;
            if ('operationIdUtm' in response) {
              localStorage.setItem('operationIdUtm', response.operationIdUtm);
            }
          }
        } else {
          let errorMessage = data.message;
          let statusCode = data.status;
          if (statusCode === 400) {
            console.log(`Status Code: ${statusCode} - Message: ${errorMessage}`);
          } else if (statusCode === 500) {
            console.log('Error interno.');
          }
        }
      })
      .catch(e => {
        console.log(e);
      });
  } else if (visitor && partnerId) {
    //Crear utm en db
    let payload = {
      partnerId: partnerId,
      clickId: visitor
    }
    UtmLeadService.createUtmLead({ payload })
      .then((data) => {
        if (data.error === false) {
          if ('data' in data.message) {
            let response = data.message.data;
            if ('operationIdUtm' in response) {
              localStorage.setItem('operationIdUtm', response.operationIdUtm);
            }
          }
        } else {
          let errorMessage = data.message;
          let statusCode = data.status;
          if (statusCode === 400) {
            console.log(`Status Code: ${statusCode} - Message: ${errorMessage}`);
          } else if (statusCode === 500) {
            console.log('Error interno.');
          }
        }
      })
      .catch(e => {
        console.log(e);
      });
  }

  return (
    <>
      <div>
        <TagManager />
        <Hero />
        <Requisitos />
        <Benefits />
        <Feature />
        <FeatureTwo />
        <Space />
      </div>
    </>
  );


}
